export default "__VITE_ASSET__B5YR5AWC__"